import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import {
  createTheme,
  ThemeProvider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@material-ui/core";
import { CustomizedTableFooter } from "../../../custom/CustomizedTableFooter";
import { useStyles } from "../../../../shared/styles/useStyles";
import { AppState } from "../../../../redux/reducers/rootReducer";
import { DocumentaryTypeBody } from "./DocumentaryTypeBody";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { Colors } from "../../../../shared/constants/themes/Colors";
import { ITrdDocumentalType } from "../../../../redux/types/types";
import {FC, useState} from "react";
import { counter } from "../../../../helpers/count";
const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});
interface props {
  documentalType: ITrdDocumentalType[];
}
export const DocumentaryTypeTable:FC<props> = ({documentalType}) => {
  const classes = useStyles();
  const { data, value } = useSelector((state: AppState) => state.search);
  //const { documentalType } = useSelector((state: AppState) => state.trd);

  // Paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const count = counter( value, documentalType, data );
  const filteredList: ITrdDocumentalType[] = value.trim()
    ? (data as ITrdDocumentalType[])
    : documentalType;
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, filteredList.length - page * rowsPerPage);

  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        {documentalType.length <= 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ height: 200 }}
            className={classes.title}
          >
            <InfoOutlinedIcon style={{ fontSize: 30, color: Colors.ACCENT }} />
            <FormattedMessage id={"NoCreatedDocumentalType"} />
          </Box>
        ) : (
          <Table
            className={classes.table}
            size="small"
            style={{ tableLayout: "auto" }}
            aria-label="a dense table"
          >
            <TableHead className={classes.titleTable}>
              <TableRow>
                <TableCell
                  width={"10%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="CodeOP" />{" "}
                </TableCell>
                <TableCell
                  width={"20%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="SeriesCode" />{" "}
                </TableCell>
                <TableCell
                  width={"10%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="SubseriesCode" />{" "}
                </TableCell>
                <TableCell
                  width={"20%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="DocumentalTypeCode" />{" "}
                </TableCell>
                <TableCell
                  width={"10%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="DocumentalTypeName" />{" "}
                </TableCell>
                <TableCell
                  width={"10%"}
                  className={classes.titleTable}
                  align="center"
                >
                  <FormattedMessage id="Actions" />{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <DocumentaryTypeBody key={row.code} documentalType={row} />
                ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 13 * emptyRows }}>
                  <TableCell colSpan={12} />
                </TableRow>
              )}
            </TableBody>
            {/* --------- Footer para paginación -------- */}
            <CustomizedTableFooter
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={(_, newPage) => setPage(newPage)}
              onChangeRowsPerPage={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </Table>
        )}
      </TableContainer>
    </ThemeProvider>
  );
};
